import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M5.916 15.942l-5.81-5.808L1.378 8.86l4.538 4.537L16.622 2.693l1.272 1.274z" />
  </svg>
);

export default SvgComponent;
